import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SchedaCoopGaranziaFidiFormService } from './scheda-coop-garanzia-fidi-form.service';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [SchedaCoopGaranziaFidiFormService],
})
export class SchedaCoopGaranziaFidiFormModule {}